import { PageContainer } from "@/components/common/page-container";
import { WorkspaceGeneralSetting } from "@/routes/settings/workspace/components/workspace-general-setting";
import { Loading, UnderlineTabs, UnderlineTabsContent, UnderlineTabsList, UnderlineTabsTrigger } from "@backpac/monica";
import { Suspense } from "react";
import { useSearchParams } from "react-router";
import type { ValueOf } from "type-fest";
import { WorkspaceMembersSetting } from "./components/workspace-members-setting";

const WorkspaceSetting = {
  General: {
    label: "General",
    value: "general",
  },
  Members: {
    label: "Members",
    value: "members",
  },
} as const;

function useWorkspaceSetting() {
  const [searchParams, setSearchParams] = useSearchParams();
  const tab = (searchParams.get("tab") ?? WorkspaceSetting.General.value) as ValueOf<typeof WorkspaceSetting>["value"];

  const handleTabChange = (value: string) => {
    setSearchParams({ tab: value });
  };

  return {
    tab,
    handleTabChange,
  };
}

export function SettingsWorkspacePage() {
  const { tab, handleTabChange } = useWorkspaceSetting();

  return (
    <PageContainer nav={<PageContainer.Navigation title="Workspace Settings" />}>
      <UnderlineTabs defaultValue={tab} onValueChange={handleTabChange}>
        <UnderlineTabsList>
          <UnderlineTabsTrigger value={WorkspaceSetting.General.value}>
            {WorkspaceSetting.General.label}
          </UnderlineTabsTrigger>
          <UnderlineTabsTrigger value={WorkspaceSetting.Members.value}>
            {WorkspaceSetting.Members.label}
          </UnderlineTabsTrigger>
        </UnderlineTabsList>
        <UnderlineTabsContent value={WorkspaceSetting.General.value}>
          <Suspense fallback={<Loading className="min-h-[400px]" />}>
            <WorkspaceGeneralSetting />
          </Suspense>
        </UnderlineTabsContent>
        <UnderlineTabsContent value={WorkspaceSetting.Members.value}>
          <Suspense fallback={<Loading className="min-h-[400px]" />}>
            <WorkspaceMembersSetting />
          </Suspense>
        </UnderlineTabsContent>
      </UnderlineTabs>
    </PageContainer>
  );
}
